import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { FormContainer, PasswordRepeatElement, useForm } from 'react-hook-form-mui';
import { AuthContext } from './AuthContext';
import ValidatedTextField from '../Utilities/Forms/ValidatedTextField';
import Alert from '@mui/material/Alert';
import ReturnViewModel from '../Contexts/ReturnViewModel';
import ResetPasswordViewModel from './ViewModels/ResetPasswordViewModel';

export default function ResetPassword() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const token = (params.get('token'));
    const userId = (params.get('user'));
    const formContext = useForm<ResetPasswordViewModel>({
        defaultValues: new ResetPasswordViewModel(),
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<ReturnViewModel | null>(null);
    const { resetPassword } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token || !userId) {
            navigate('/authorisation/login');
        }
    }, [token, userId]);


    const handleResetPassword = async (payload: ResetPasswordViewModel) => {
        payload.token = token!;
        payload.id = userId!;
        setLoading(true)
        resetPassword(payload, (result) => {
            setLoading(false);
            setResponse(result);
        });
    };

    return (
        <FormContainer
            formContext={formContext}
            onSuccess={handleResetPassword}
        >
            <Grid container>
                <Grid size={12}>
                    <Typography variant="h4">Reset Password</Typography>
                </Grid>
                {response !== null && response.success ?
                    <>
                        <Grid size={12}>
                            <Alert severity="success">Your password has been reset</Alert>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Button variant="text" size="small" onClick={() => navigate('/authorisation/login')} disabled={loading}>Return to sign in</Button>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid size={12}>
                            <InputLabel htmlFor="password" shrink>New Password</InputLabel>
                            <ValidatedTextField name='password' type='password' />
                        </Grid>
                        <Grid size={12}>
                            <InputLabel htmlFor="confirmPassword" shrink>Confirm New Password</InputLabel>
                            <PasswordRepeatElement name='password-repeat' passwordFieldName='password' size='small' fullWidth />
                        </Grid>
                        {response !== null && !response.success &&
                            <Grid size={12}>
                                <Alert severity="error">{response.messages[0]}</Alert>
                            </Grid>
                        }
                        <Grid size={{ xs: 12 }}>
                            <Button type="submit" disabled={loading}>Submit</Button>
                        </Grid>
                    </>
                }
            </Grid>
        </FormContainer>
    );
}
